import { DEFAULT_VISIBLE_PAGES } from '../constants';

export const getVisiblePageRange = (
  currentPage: number,
  totalPages: number,
  maxVisible: number = DEFAULT_VISIBLE_PAGES,
): { startPage: number; endPage: number } => {
  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let endPage = Math.min(totalPages, startPage + maxVisible - 1);

  if (endPage - startPage < maxVisible - 1) {
    startPage = Math.max(1, endPage - maxVisible + 1);
  }

  return { startPage, endPage };
};
